/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkey_Error_Not_SupportedInputs */



/**
* | output |
* | --- |
* | "Passkeys aren't supported in this browser." |
*
* @param {Passkey_Error_Not_SupportedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const passkey_error_not_supported = /** @type {((inputs?: Passkey_Error_Not_SupportedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_Error_Not_SupportedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les Passkeys ne sont pas prises en charge par ce navigateur.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los Passkeys no son compatibles con este navegador.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Passkeys não são suportadas neste navegador.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le passkey non sono supportate in questo browser.")
	return /** @type {LocalizedString} */ ("Passkeys aren't supported in this browser.")
});